import {
  DialogTitle as MuiDialogTitle,
  IconButton,
  Typography,
  withStyles
} from '@material-ui/core';
import { BackButton } from '../../../Pickups/PickupInfoPopup/components';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
  dialogTitle: {
    padding: '8 14',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  title: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    top: '19px',
    display: 'flex',
    alignItems: 'center'
  },
  closeButton: {
    color: theme.iconColor,
    marginLeft: 18,
    padding: 0
  },
  grayBar: {
    height: 1,
    backgroundColor: theme.AppBGColor,
  }
});

const DialogHeader = (props) => {
  const { classes, title, onClose, ...other } = props;
  return (
    <>
      <MuiDialogTitle disableTypography classes={{ root: classes.dialogTitle }} {...other}>
        <Typography variant="h6" className={classes.title}>
          <BackButton onClick={onClose} />
          {title}
        </Typography>
        <div>
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </MuiDialogTitle>
      <div className={classes.grayBar}></div>
    </>
  );
};

export default withStyles(styles)(DialogHeader);
